import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  CircularProgress,
  Typography,
  Paper,
} from '@mui/material';

const WorkflowFlowView = () => {
  const { id } = useParams();
  const [workflow, setWorkflow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWorkflow = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/active-workflows/${id}`);
        setWorkflow(response.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError('Failed to load workflow');
        setLoading(false);
      }
    };

    fetchWorkflow();
  }, [id]);

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Workflow Graph
      </Typography>

      {workflow ? (
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
          }}
        >
          {workflow.nodes.map((node, idx) => {
            const isCurrent = workflow.currentApprover === node.id;
            const isFinal = workflow.finalApprovers.includes(node.id);;

            return (
              <React.Fragment key={node.id}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  {/* Arrow section */}
                  <Box sx={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {isCurrent && (
                      <Typography variant="h6" sx={{ lineHeight: 1 }}>
                        ↓
                      </Typography>
                    )}
                  </Box>

                  {/* Node display */}
                  <Paper
                    elevation={4}
                    sx={{
                      px: 2,
                      py: 1,
                      bgcolor: isFinal ? 'success.main' : 'grey.200',  // Final approver = green
                      color: isFinal ? 'white' : 'black',
                      borderRadius: 1,
                      minWidth: 80,
                      textAlign: 'center',
                    }}
                  >
                    {node.name}
                  </Paper>
                </Box>

                {/* Arrow to next node */}
                {idx < workflow.nodes.length - 1 && (
                  <Typography sx={{ mx: 2, mt: 3 }}>&rarr;</Typography>
                )}
              </React.Fragment>
            );
          })}
        </Box>
      ) : (
        <Typography>No data</Typography>
      )}
    </Box>
  );
};

export default WorkflowFlowView;
